import { useEffect, useState } from 'react';
import { AddContactRequest, ContactsRequest, SingleContact } from 'vopay';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useContacts() {
  const source = axios.CancelToken.source();
  const [pending, setPending] = useState(false);
  const [contact, setContact] = useState<SingleContact | null>(null);
  const [contacts, setContacts] = useState<SingleContact[]>([]);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function createContact(params: AddContactRequest) {
    try {
      setPending(true);
      const res = await api.addContact(params, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return {
        contactID: res.ContactID,
      };
    } finally {
      setPending(false);
    }
  }

  async function fetchContact(contactID: string) {
    try {
      setPending(true);
      const res = await api.fetchContacts(
        {
          ContactID: contactID,
        },
        source,
      );

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      const contact = res.Contacts.length > 0 ? res.Contacts[0] : null;
      setContact(contact);

      return res;
    } finally {
      setPending(false);
    }
  }

  async function fetchContacts(params: ContactsRequest) {
    try {
      setPending(true);
      const res = await api.fetchContacts(params, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setContacts(res.Contacts);

      return res;
    } finally {
      setPending(false);
    }
  }

  return {
    pending,
    createContact,
    contact,
    fetchContact,
    contacts,
    fetchContacts,
  };
}
